import {useContext, useState} from "react";
import CommandeAPI from "../../services/CommandeAPI";
import AuthContext from "../../contexts/AuthContext";
import {createBlobUrl} from '../../Tools/File'

export const useSavs = () => {
    const [showModalOrder, setShowModalOrder] = useState(false);
    const [showModalSav, setShowModalSav] = useState(false);
    const [orderNumber, setOrderNumber] = useState();
    const [sav, setSav] = useState();
    const [pdf, setPdf] = useState(null);
    const {user} = useContext(AuthContext);

    async function handleShowOrder(orderNumber) {
        setOrderNumber(orderNumber);

        await CommandeAPI.getPDF(orderNumber)
            .then(({data, status}) => {
                if (status === 200) {
                    setPdf(createBlobUrl(data))
                    setShowModalOrder(true);
                }
            })
        ;
    }

    const handleShowSav = (sav) => {
        setShowModalSav(true);
        setSav(sav);
    }

    return {
        showModalOrder,
        setShowModalOrder,
        orderNumber,
        pdf,
        setOrderNumber,
        handleShowOrder,
        showModalSav,
        setShowModalSav,
        sav,
        setSav,
        handleShowSav
    };
}
